import { success } from '@/utils/alert'

export default {
  afterCreated () {
    success('Funcionário associado com sucesso.')
  },
  doAttach () {
    this.$v.$touch()
    this.$nextTick(() => this.focusFirstStatus())

    if (this.$v.$error) {
      return
    }
    const registerEmpployer = this.employee
    this.$http.post('/v1/professional/companies/employees/attach', registerEmpployer)
      .then(() => {
        this.afterCreated()
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/form/resources/methods.js